import formatMoney from "./formatMoney"
import type { AmountOption, AmountOptionKey } from "./model"
import { useT } from "@/i18n"
import { RadioGroupField } from "@/ui/composed"

type Props = {
  readonly options: readonly AmountOption[]
  readonly value: AmountOptionKey
  readonly onChange: (key: AmountOptionKey) => void
}

export default function AmountSelector({ options, value, onChange }: Props) {
  const { t } = useT("money")

  const radios = options.map((option) => ({
    value: option.key,
    label: `${t(`amount.${option.key}`)} — ${t("amount.option", {
      credits: option.credits,
      total: formatMoney(option.total),
    })}`,
  }))

  return (
    <RadioGroupField
      label={t("amount.label")}
      value={value}
      onChange={(key) => {
        onChange(key as AmountOptionKey)
      }}
      options={radios}
    />
  )
}
